/**
 * ============================================================
 * 收集触发点配置（场景中的"点击收集"按钮）
 * ============================================================
 * PC 和移动端共用此配置
 *
 * 所有数值基于设计稿坐标（1920×1080），运行时自动乘以 scaleRatio
 *
 * left   - 触发按钮横向位置
 * top    - 触发按钮纵向位置
 * height - 触发按钮高度（默认 triggerButtonHeight）
 * scene  - 对应的场景索引（0-8），用于九宫格收集
 *
 * popup  - 弹框配置（配了则点击先弹框，弹框内点收集按钮再收集）
 *   display        - "scene"（跟随场景滚动） | "overlay"（浮层居中，默认）
 *   src            - 弹框图片路径
 *   width          - 弹框宽度
 *   left           - 弹框横向位置（scene 模式，不设则自动居中到触发按钮）
 *   top            - 弹框纵向位置（scene 模式，不设则默认 80）
 *   collectSrc     - 收集按钮图片（不设则用 popup.js 默认值）
 *   collectHeight  - 收集按钮高度（不设则用 popup.js 默认值 60）
 *   collectOffsetX - 收集按钮水平偏移，正值右移负值左移（不设则居中）
 *   collectOffsetY - 收集按钮距弹框底部偏移（不设则用 popup.js 默认值 20）
 *   hideClose      - 是否隐藏关闭按钮（true 隐藏，不设则显示）
 */
export var triggerButtonSrc = "./xiangan/dianji.webp";

export var triggerButtonHeight = 240;

export var collectTriggers = [
  { left: 4234,  top: 412, scene: 0, popup: { display: "scene", src: "./9/poups/1.webp", width: 813, left: 4400, top: 200, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -40, collectOffsetY: -190, hideClose: true } },
  { left: 9810,  top: 250, scene: 1, popup: { display: "scene", src: "./9/poups/2.webp", width: 813, left: 9670, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -10, collectOffsetY: -235, hideClose: true } },
  { left: 11405, top: 505, scene: 2, popup: { display: "scene", src: "./9/poups/3.webp", width: 813, left: 11215, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -10, collectOffsetY: -200, hideClose: true } },
  { left: 17382, top: 174, scene: 3, popup: { display: "scene", src: "./9/poups/4.webp", width: 813, left: 17242, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -35, collectOffsetY: -235, hideClose: true } },
  { left: 20562, top: 587, scene: 4, popup: { display: "scene", src: "./9/poups/5.webp", width: 813, left: 20422, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -5, collectOffsetY: -180, hideClose: true } },
  { left: 22503, top: 366, scene: 5, popup: { display: "scene", src: "./9/poups/6.webp", width: 813, left: 22363, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: 10, collectOffsetY: -250, hideClose: true } },
  { left: 25233, top: 30, scene: 6, popup: { display: "scene", src: "./9/poups/7.png", width: 813, left: 24893, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: -40, collectOffsetY: -180, hideClose: true } },
  { left: 29936, top: 45,  scene: 7, popup: { display: "scene", src: "./9/poups/8.webp", width: 813, left: 29876, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: 0, collectOffsetY: -145, hideClose: true } },
  { left: 33730, top: 150, scene: 8, popup: { display: "scene", src: "./9/poups/9.webp", width: 813, left: 33590, top: 80, collectSrc: "./9/poups/开心收下.webp", collectHeight: 100, collectOffsetX: 10, collectOffsetY: -200, hideClose: true } },
];

